import { render, staticRenderFns } from "./ProductDetailRichTextTemplate.vue?vue&type=template&id=00016316&scoped=true"
import script from "./ProductDetailRichTextTemplate.vue?vue&type=script&lang=js"
export * from "./ProductDetailRichTextTemplate.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailRichTextTemplate.vue?vue&type=style&index=0&id=00016316&prod&lang=css"
import style1 from "./ProductDetailRichTextTemplate.vue?vue&type=style&index=1&id=00016316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00016316",
  null
  
)

export default component.exports